import React, { useState } from 'react';
import GoogleIcon from "../../../assets/icons/google-icon.svg"
import { useGoogleLogin } from '@react-oauth/google';
import Swal from "sweetalert2";

export default function GoogleAuthRemember(props) {
    const googleLogin = useGoogleLogin({
        onSuccess: async (tokenResponse) => {
            props.action(tokenResponse.access_token)
        },
        onError: () => {},
    });

    const handleClick = async () => {
        const result = await Swal.fire({
            title: 'Peringatan!',
            text: `Apakah Anda yakin ingin mengaktifkan opsi "Ingat Saya"? Dengan mengaktifkan opsi ini, informasi login Anda akan disimpan pada perangkat ini selama 1 bulan, sehingga Anda tidak perlu memasukkan kredensial Anda setiap kali Anda mengakses akun Anda.`,
            confirmButtonText: 'Lanjutkan',
            showCancelButton: true,
            cancelButtonText: 'Batal',
            icon: 'warning',
        });

        if (result.isConfirmed) {
            googleLogin();
        }
    };

    return (
        <button
            className="btn btn-primary loginv2-button-login"
            onClick={handleClick}
        >
            <img alt="" src={GoogleIcon} style={{ width: "16px", height: "16px", marginRight: 8 }} />
            <span className='fs-10'>Lanjutkan dengan Google</span>
        </button>
    );
}